var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrmIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 0 24 24",
    width: "20px",
    fill: "#3A3A3A",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 10c1.38 0 2.5-1.12 2.5-2.5S19.88 5 18.5 5c-.32 0-.62.07-.9.18 1.14.73 1.9 2 1.9 3.32 0 1.32-.76 2.59-1.9 3.32.28.11.58.18.9.18z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13c-.48 0-.96.06-1.42.17 1.48.91 2.42 2.28 2.42 3.83V19h2.5v-2c0-2.21-3.58-4-3.5-4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10c-1.38 0-2.5-1.12-2.5-2.5S4.12 5 5.5 5c.32 0 .62.07.9.18-1.14.73-1.9 2-1.9 3.32 0 1.32.76 2.59 1.9 3.32-.28.11-.58.18-.9.18z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13c.48 0 .96.06 1.42.17-1.48.91-2.42 2.28-2.42 3.83V19H2v-2c0-2.21 3.58-4 3.5-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmIcon);
export default __webpack_public_path__ + "static/media/crm_icon.aef89f8f631912b58ae2280d64222a7b.svg";
export { ForwardRef as ReactComponent };